import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";
import {HomeMatchPreferencesSurveyCompletionDatePills} from "./HomeMatchPreferencesSurveyCompletionDatePills";

const {ADDITIONAL_EXPECTATIONS, COMPLETION_DATE} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyAdditionalFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const constructionEndDate = watch("constructionEndDate");
    const additionalExpectations = watch("additionalExpectations");

    const toggleExpectation = (value: number) => {
        const nextExpectations = additionalExpectations.includes(value)
            ? additionalExpectations.filter((expectation) => expectation !== value)
            : [...additionalExpectations, value];

        setValue("additionalExpectations", nextExpectations, {shouldDirty: true});
    };

    return (
        <>
            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {COMPLETION_DATE}
                </Text>
                <HomeMatchPreferencesSurveyCompletionDatePills
                    onChange={(value) => setValue("constructionEndDate", value, {shouldDirty: true})}
                    value={constructionEndDate}
                />
            </div>

            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {ADDITIONAL_EXPECTATIONS}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS.map((option) => (
                        <HomeMatchPreferencesSurveyPill
                            isSelected={additionalExpectations.includes(option.value)}
                            key={option.value}
                            label={option.label}
                            onSelect={() => toggleExpectation(option.value)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";
import {HomeMatchPreferencesSurveyCompletionDatePills} from "./HomeMatchPreferencesSurveyCompletionDatePills";

const {ADDITIONAL_EXPECTATIONS, COMPLETION_DATE} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyAdditionalFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const constructionEndDate = watch("constructionEndDate");
    const additionalExpectations = watch("additionalExpectations");

    const toggleExpectation = (value: number) => {
        const nextExpectations = additionalExpectations.includes(value)
            ? additionalExpectations.filter((expectation) => expectation !== value)
            : [...additionalExpectations, value];

        setValue("additionalExpectations", nextExpectations, {shouldDirty: true});
    };

    return (
        <>
            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {COMPLETION_DATE}
                </Text>
                <HomeMatchPreferencesSurveyCompletionDatePills
                    onChange={(value) => setValue("constructionEndDate", value, {shouldDirty: true})}
                    value={constructionEndDate}
                />
            </div>

            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {ADDITIONAL_EXPECTATIONS}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_ADDITIONAL_EXPECTATIONS.map((option) => (
                        <HomeMatchPreferencesSurveyPill
                            isSelected={additionalExpectations.includes(option.value)}
                            key={option.value}
                            label={option.label}
                            onSelect={() => toggleExpectation(option.value)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});
